<rid-flash-amount (finished)="$router.navigate(['/mechanics/formule'])" [numbers]="numbers()" class="h-dvh" />
